import Vue from 'vue'

import withRender from './progress-bar.html'
import './progress-bar.scss'

export default withRender(Vue.extend({
  data() {
    return {}
  },
  props: {
    minValue: {
      type: Number,
      default: 0
    },
    maxValue: { type: Number },
    value: { type: Number }
  },
  computed: {
    progressPercent() {
      if (this.maxValue) {
        return ((this.value - this.minValue) / (this.maxValue - this.minValue)) * 100
      }
      return 0
    },
    progressStyles() {
      return { width: `${this.progressPercent}%` }
    }
  }
}))



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/objects/progress/progress-bar.ts